import Splide from '@splidejs/splide';

(function (Drupal, once) {
  Drupal.behaviors.carousel = {
    attach(context) {
      once('splide', '.splide', context).forEach((el) => {
        new Splide(el).mount();
      });
    },
  };
}(Drupal, once));
